<template>
  <div class="bg-white" style="padding-bottom: 75px;padding-top: 30px;">
    <div class="min-main article-box">
      <div class="article-con">
        <div class="expert-info">
          <div class="expert-avatar">
            <img v-if="detailsRes.photo" :src="detailsRes.photo" alt="expert photo" />
            <img v-else src="@/assets/images/default-avatar.png">
          </div>
          <div class="expert-name">
            {{ detailsRes.name }}
            <div v-if="showDetail" class="expert-brief" v-html="detailsRes.intro"></div>
            <div v-else class="expert-brief" v-html="detailsRes.intro"></div>
          </div>
        </div>
      </div>
      <!-- <h1>{{ detailsRes.newsTitle }}</h1> -->
      <!-- <div class="other-info justify-between items-center">
            <div class="items-center">
              <div class="items-center">
                <svg-icon icon-class="Group 1941"></svg-icon>
                <span>{{ detailsRes.releaseTime }}</span>
              </div>
              <div class="items-center" v-if="detailsRes.author">
                <svg-icon icon-class="pen"></svg-icon>
                <span>{{ L('作者') }} {{ detailsRes.author }}</span>
              </div>
              <div class="items-center">
                <svg-icon icon-class="Path 617"></svg-icon>
                <span>{{ detailsRes.tips }}</span>
              </div>
            </div>
            <div class="items-center">
              <div class="items-center">
                <div id="fb-root"></div>
                <div class="social-share" data-sites="qq,weibo,wechat,facebook"></div>
              </div>

            </div>
          </div> -->
      <!-- <div class="details" v-if="showDetail" v-html="detailsRes.newsContent"></div>
      <div class="" v-else v-text="detailsRes.brief"></div> -->

      <!-- <div class="tags items-center" v-if="detailsRes.tag && detailsRes.tag.length > 0">
        <svg-icon icon-class="Group 3022"></svg-icon>
        <span v-for="item in detailsRes.tag" :key="item">{{ item }}</span>
      </div> -->

      <template v-if="detailsRes.price > 0">
        <Unlock :item='detailsRes' v-if="detailsRes.newsContent && !showDetail" @unlock="showDetail = true" />
        <Read :item='detailsRes' v-if="!detailsRes.newsContent" />
      </template>

      <RelatedArticle :authorId="String(detailsRes.id)" />


    </div>
    <!-- <div class="relate-news">
            <Person :list="personList"/>
            <News :list="hotList"/>
        </div> -->
  </div>
</template>

<script>
import { getNewsDetails, getNewsList, getExpertDetails } from "@/assets/api/news.js";

import Person from "../expert/person.vue";
import News from '../expert/news.vue'
import Read from './read.vue'
import Unlock from './unlock.vue'
import RelatedArticle from '../article-details/components/related-article.vue'

export default {
  components: {
    Person,
    News,
    Read,
    Unlock,
    RelatedArticle,
  },

  data() {
    return {
      id: '',
      detailsRes: {},
      personList: [],
      hotList: [],
      showDetail: false,
    };
  },


  created() {
    this.id = this.$route.params.id;

    getExpertDetails({ id: this.$route.params.id }).then((res) => {
      console.log('getNewsDetails', res)
      this.detailsRes = res.data.data || {};
      this.detailsRes.tag = this.detailsRes.tag
        ? this.detailsRes.tag.split("|")
        : [];
      this.detailsRes.photo = this.detailsRes.photo ? !/^http/.test(this.detailsRes.photo)
        ? this.$imgUrl + this.detailsRes.photo
        : this.detailsRes.photo : '';
      let cfg = {
        url: 'https://www.ts960.com/share/article/' + this.detailsRes.id + '.html', // 网址，默认使用 window.location.href
        // source              : '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: this.detailsRes.name, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        // origin              : '', // 分享 @ 相关 twitter 账号
        // description         : '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        // image               : '', // 图片, 默认取网页中第一个img标签
        // title               : '234',
        // description         : '123',
        // sites               : ['qq', 'weibo','wechat', 'facebook'], // 启用的站点
        // disabled            : ['douban', 'diandian'], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper: '<p>微信扫一扫</p><p>二维码便可将本文分享至朋友圈。</p>',
      };

      socialShare('.social-share', cfg);
      this.$forceUpdate()
    });

    // this.getPersonList();
    // this.getHotList();
  },
  methods: {
    getPersonList() {
      getNewsList({
        orderByColumn: "tips",
        isAsc: "desc",
        pageNum: 1,
        pageSize: 4,
        slideshow: 0,
        typeId: 20,
      }).then((res) => {
        this.personList = res.data.rows.map((item) => {
          item.newsImage = !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage;
          item.author = item.authorV2 ? item.authorV2 : item.author;
          item.authorAvatar = item.authorAvatarV2 ? item.authorAvatarV2 : item.authorAvatar;
          item.authorAvatar = !/^http/.test(item.authorAvatar)
            ? this.$imgUrl + item.authorAvatar
            : item.authorAvatar;
          return item;
        });
      });
    },
    getHotList() {
      getNewsList({
        orderByColumn: "tips",
        isAsc: "desc",
        pageNum: 1,
        pageSize: 4,
        slideshow: 0,
        typeId: 19,
      }).then((res) => {
        this.hotList = res.data.rows.map((item) => {
          item.newsImage = !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage;
          return item;
        });
      });
    },
    tofacebook() {
      let vm = this;
      console.log(window.location.href);
      FB.init({
        appId: "1951935595172355",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v2.12",
      });
      FB.ui(
        {
          method: "share", // 分享方式
          mobile_iframe: true,
          href: `https://ts960.com/share/article/${vm.detailsRes.newsId}.html`, // 分享的连接
        },
        function (response) { }
      );
    },

  },
};
</script>
<style lang="less" scoped>
.article-con {
  flex: 1;

  .banner1 {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }

  h1 {
    font-family: NotoSansCJKTC;
    font-size: 40px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 4px;
    text-align: left;
    color: #000;
    padding: 30px 0;
  }

  .other-info {
    padding-bottom: 12px;
    border-bottom: 1px solid #e13133;
    margin-bottom: 35px;

    div {
      margin-right: 30px;
    }

    .svg-icon {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }

    span {
      font-family: NotoSansCJKTC;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.05;
      letter-spacing: normal;
      text-align: left;
      color: #e13133;
    }
  }

  .details {
    line-height: 2.19;
    letter-spacing: 0.8px;
    color: #000;
  }

  .tags {
    margin-top: 50px;

    .svg-icon {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }

    span {
      font-family: NotoSansCJKTC;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.58;
      letter-spacing: 1.2px;
      text-align: center;
      color: #e13133;
      padding: 3px 24px;
      border: solid 1px #e13133;
      margin-right: 10px;
    }
  }

}

.expert-info {
  // width: 800px;
  // height: 160px;
  background: #F2F2F7;
  border-radius: 16px;
  padding: 30px;
  display: flex;
  align-items: center;

  .expert-avatar {
    width: 100px;
    height: 100px;
    border: 2px solid #E5E5EA;
    border-radius: 50%;
    margin-right: 20px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .expert-name {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 24px;
    color: #2C2C2E;
    line-height: 31px;
    text-align: left;
    font-style: normal;
  }

  .expert-brief {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #AEAEB2;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    margin-top: 8px;
  }
}


.relate-news {
  width: 400px;
  margin-left: 30px;

  .banner2 {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .banner3 {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .news-list {
    h2 {
      font-family: NotoSansCJKTC;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 29px;
      letter-spacing: normal;
      text-align: left;
      color: #222;
      padding: 6px 0;
      margin-top: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e13133;
    }

    .news-item {
      margin-bottom: 10px;

      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-right: 10px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: 0.7px;
        text-align: center;
        color: #8b8b8b;
        margin-bottom: 2px;
      }

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 2.4px;
        text-align: left;
        color: #222;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
  }
}


@media screen and (max-width: 768px) {
  .article-con {
    flex: 1;
    margin: 0 20px;

    .expert-avatar {
      width: 68px;
      height: 68px;
    }
    .expert-name{
      font-size: 16px;
      line-height: 21px;
    }

    .banner1 {
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    h1 {
      font-size: 18px;
      padding: 15px;
    }

    .other-info {
      padding: 0;
      padding-bottom: 10px;
      border-bottom: 1px solid #e13133;
      margin: 0 15px;
      margin-bottom: 16px;

      div {
        margin-right: 12px;
      }

      .svg-icon {
        width: 16px;
        height: 16px;
        margin-right: 3px;
      }

      span {
        font-family: NotoSansCJKTC;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.09;
        letter-spacing: normal;
        text-align: left;
        color: #e13133;
      }
    }

    .details {
      line-height: 2.19;
      letter-spacing: 0.8px;
      color: #000;
    }

    .tags {
      margin: 30px 15px;
    }

  }

  .relate-news {
    width: 100%;
    padding: 0 15px;
    margin: 0;

    .banner2 {
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    .banner3 {
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    .news-list {
      h2 {
        font-family: NotoSansCJKTC;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 29px;
        letter-spacing: normal;
        text-align: left;
        color: #222;
        padding: 6px 0;
        margin-top: 15px;
        margin-bottom: 20px;
        border-bottom: 1px solid #e13133;
      }

      .news-item {
        margin-bottom: 10px;

        img {
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }

        time {
          font-family: NotoSansCJKTC;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.71;
          letter-spacing: 0.7px;
          text-align: center;
          color: #8b8b8b;
          margin-bottom: 2px;
        }

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: 2.4px;
          text-align: left;
          color: #222;
        }
      }
    }
  }

  .article-box {
    flex-direction: column;
  }
}
</style>
<style>
.details img {
  display: block;
  max-width: 90%;
  height: auto;
  margin: 35px auto;
}

.details video {
  width: 100%;
  height: auto;
}

.details iframe {
  width: 100%;
  height: 500px;
  max-width: 100%;
}

@media screen and (max-width: 768px) {
  .details img {
    max-width: 100%;
    margin: 15px auto;
  }

  .details iframe {
    width: 100%;
    height: 300px;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/expert-details/index.vue